import { Typography } from 'antd';
import * as React from 'react';

import styles from './Page.module.less';

export interface PageProps {
  title?: string;
  children: React.ReactNode;
}

export function Page({ title, children }: PageProps) {
  return (
    <div className={styles.container}>
      {title ? <Typography.Title level={1}>{title}</Typography.Title> : null}
      {children}
    </div>
  );
}
